import { render } from "./MailsList.vue?vue&type=template&id=25ffdebc"
import script from "./MailsList.vue?vue&type=script&lang=js"
export * from "./MailsList.vue?vue&type=script&lang=js"

import "./MailsList.vue?vue&type=style&index=0&id=25ffdebc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__